// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__kUwmV","emails":"CreateEditClinics_emails__2fqFO","emailTagLabel":"CreateEditClinics_emailTagLabel__3wUOF"};